<template>
  <div>
    <input
      :type="type"
      :class="[
        'block w-full px-4 py-3 text-base border rounded-xl font-sans transition-all duration-200 focus:outline-none hover:border-primary-light shadow-sm hover:shadow-md',
        isValid === false ? 'border-warning text-warning focus:ring-warning focus:border-warning bg-red-50' : 'border-gray-300 text-anthracite focus:ring-primary focus:border-primary bg-white',
        isValid === true ? 'border-success text-success focus:ring-success focus:border-success bg-green-50' : '',
        'focus:ring-2 focus:ring-offset-1 focus:ring-opacity-50',
        disabled ? 'opacity-60 cursor-not-allowed bg-gray-100' : '',
        inputClass
      ]"
      v-bind="$attrs"
      :disabled="disabled"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <p v-if="validationMessage" class="text-warning text-xs italic mt-0.5">{{ validationMessage }}</p>
  </div>
</template>
<script>
export default {
  name: 'InputField',
  inheritAttrs: false,
  props: {
    modelValue: [String, Number],
    isValid: {
      type: Boolean,
      default: null
    },
    validationMessage: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    }
  }
};
</script>

